//
import type { AxiosCollection } from '@/types/Components/Response'
import type { Pickup } from '@/types/Models/Pickup'
import type { PickupStoreState } from '@/types/Store'
import type { AxiosError } from 'axios'
import { defineStore } from 'pinia'
import { catchErrors } from '@/services/Helpers'
import PickupProxy from '@/proxies/PickupProxy'
import PickupTransformer from '@/transformers/PickupTransformer'

export const usePickupStore = defineStore('pickup', {
  state: (): PickupStoreState => ({
    loading: false,
    pickupsList: [],
    pickupsCount: 0,
  }),
  actions: {
    fetch(filter: object) {
      this.loading = true

      return new PickupProxy(filter)
        .all()
        .then((pickups: AxiosCollection<Pickup>) => {
          this.pickupsList = PickupTransformer.fetchCollection(pickups.data || [])
          this.pickupsCount = pickups.count || 0
          return pickups
        })
        .catch((error: AxiosError) => {
          catchErrors(error)
          this.pickupsList = []
          this.pickupsCount = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
})

export type PickupStore = ReturnType<typeof usePickupStore>
